import React from 'react'
import createHistory from 'history/createHashHistory'
import invariant from 'invariant'
import {cloneDeep, compose} from 'lodash/fp'
import {mapProps, withReducer, withProps} from 'recompose'
import {convertFormDataToSendData, formDataHasIdAndType, applyDefaultsToFormData, typeRenderHasComponent, applyDefaultsToTypeRender} from './utils'

class Wizard extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      lastStep: false,
      stepsData: props.stepsData,
      formData: props.formData
    }

    //If form has several pages initialize history component
    if(React.Children.count(props.children) !== 1) {
      if(props.history) {
        this.history = createHistory()
        this.history.replace(`${props.history.location.pathname}#0`)
        this.historySubscription = false
      } else {
        this.history = createHistory()
        this.history.replace('/0')
        this.historySubscription = false
      }
    }

    this.saveDataToWizard = this.saveDataToWizard.bind(this)
    this.previousStep = this.previousStep.bind(this)
    this.sendButton = this.sendButton.bind(this)
    this.finalStep = this.finalStep.bind(this)

    this.chooseEconomBundle = this.chooseEconomBundle.bind(this)
    this.chooseOptimalBundle = this.chooseOptimalBundle.bind(this)
    this.chooseMobileBundle = this.chooseMobileBundle.bind(this)
    this.chooseManualFeatures = this.chooseManualFeatures.bind(this)
  }

  //If form is multiform fix the back/forward button
  componentDidMount() {
    if(this.history) {
      this.historySubscription = this.history.listen((location, action) => {
        if(action === 'POP') {
          if(this.props.history) {
            this.props.stepDispatch({type: 'SET', step: Number(location.hash[1])})
          } else {
            this.props.stepDispatch({type: 'SET', step: Number(location.pathname[1])})
          }
        }
      })
    } 
  }
  componentWillUnmount() {
    this.historySubscription()
  }
  chooseEconomBundle() {
    this.setState(prevState => {
      return {
        ...prevState,
        formData: {...prevState.formData, econombundle: true}
      }
    })
    this.history.push(`${this.props.history.location.pathname}#${this.props.step + 2}`)
    this.props.stepDispatch({type: 'SET', step: 3})
  }
  chooseOptimalBundle() {
    this.setState(prevState => {
      return {
        ...prevState,
        formData: {...prevState.formData, optimalbundle: true}
      }
    })
    this.history.push(`${this.props.history.location.pathname}#${this.props.step + 2}`)
    this.props.stepDispatch({type: 'SET', step: 3})
  }
  chooseMobileBundle() {
    this.setState(prevState => {
      return {
        ...prevState,
        formData: {...prevState.formData, mobilebundle: true}
      }
    })
    this.history.push(`${this.props.history.location.pathname}#${this.props.step + 2}`)
    this.props.stepDispatch({type: 'SET', step: 3})
  }
  chooseManualFeatures(event) {
    event.preventDefault()
    event.stopPropagation()
    this.history.push(`${this.props.history.location.pathname}#${this.props.step + 1}`)
    this.props.stepDispatch({type: 'SET', step: 2})
  }
  saveDataToWizard(formState) {
    let mergeObj = {}
    for(let prop in formState) {
      mergeObj = {...mergeObj, [prop]: formState[prop].value}
    }

    this.props.formDataDispatch({type: 'ADD', formState})

    this.setState(prevState => {
      return {
        ...prevState,
        formData: {...prevState.formData, ...mergeObj},
        stepsData: prevState.stepsData.map(step => {
          return step.map(field => {
            if(mergeObj.hasOwnProperty(field.id)) {
              return {...field, value: mergeObj[field.id]}
            }
            return field
          })
        })
      }
    })

    if(this.props.step !== this.props.finalStep) {
      if(this.props.history) {
        this.history.push(`${this.props.history.location.pathname}#${this.props.step + 1}`)
      } else {
        this.history.push(`/${this.props.step + 1}`)
      }
      this.props.stepDispatch({type: 'INCREMENT'})
    }
  }

  sendButton(formState) {
    this.saveDataToWizard(formState)

    this.setState(prevState => {
      return {...prevState, lastStep: true}
    }, this.finalStep)
  }

  finalStep() {
    if(this.state.lastStep) {
      this.props.sendData(this.state.formData)
    }
  }

  previousStep() {
    if(this.props.history) {
      this.history.push(`${this.props.history.location.pathname}#${this.props.step - 1}`)
    } else {
      this.history.push(`/${this.props.step - 1}`)
    }
    this.props.stepDispatch({type: 'DECREMENT'})
  }
  render() {
    const {step, finalStep, typeRender} = this.props
    return (
      <div>
        { React.Children.map(this.props.children, (child, index) => {
          if(index !== step) {
            return null
          }
          return React.cloneElement(child,
              {
               saveDataToWizard: this.saveDataToWizard,
               sendButton: this.sendButton,
               finalStep: step === finalStep,
               previousStep: this.previousStep,
               typeRender: typeRender,
               state: this.state.stepsData[index],
               previousButton: step === 0 ?  null : typeRender.previousButton.component,
               nextButton: step === finalStep ? typeRender.finishButton.component : typeRender.nextButton.component,
               chooseEconomBundle: this.chooseEconomBundle,
               chooseOptimalBundle: this.chooseOptimalBundle,
               chooseMobileBundle: this.chooseMobileBundle,
               chooseManualFeatures: this.chooseManualFeatures
              }
            )
        }) }
      </div>
    )
  }
}

const translateProps = props => {
  if(!formDataHasIdAndType(props.formData)) {
    invariant(
      false,
      `Id and type fields must be present in all field and must be strings`
    )
  }

  if(!typeRenderHasComponent(props.typeRender)) {
    invariant(
      false,
      `Type render must have component property to render`
    )
  }

  let sendData = convertFormDataToSendData(props.formData)  

  let stepsData = compose(
    applyDefaultsToFormData,
    cloneDeep
  )(props.formData)

  const typeRender = compose(
    applyDefaultsToTypeRender,
    cloneDeep
  )(props.typeRender)

  return {...props, formData: sendData, stepsData, typeRender, history: props.history}
}

const enhanceWizard = compose(
  withReducer('formData2', 'formDataDispatch', (state, action) => {
    switch(action.type) {
      case 'ADD':
        let mergeObj = {}
        for(let prop in action.formState) {
          mergeObj = {...mergeObj, [prop]: action.formState[prop].value}
        }

        return {...state, ...mergeObj}
      default:
        return state
    }
  }, props => convertFormDataToSendData(props.formData)),
  withReducer('step', 'stepDispatch', (state, action) => {
    switch(action.type) {
      case 'INCREMENT':
        return state + 1
      case 'DECREMENT':
        return state - 1
      case 'SET':
        return action.step
      default:
        return state
    }
  }, 0),
  withProps(props => {
    return {finalStep: React.Children.count(props.children) - 1}
  }),
  mapProps(translateProps)
)(Wizard)

export default enhanceWizard


// WEBPACK FOOTER //
// ./src/formWizard/Wizard.js